import React from 'react';
import { Building, Factory, Store, Building2 } from 'lucide-react';

const PORTFOLIO_IMAGE = "https://images.pexels.com/photos/358530/pexels-photo-358530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const SERVICES_IMAGE = "https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Portfolio = () => {
  const projectTypes = [
    {
      icon: Building2,
      title: 'Escritórios Corporativos',
      description: 'Climatização de ambientes administrativos e salas comerciais.',
    },
    {
      icon: Factory,
      title: 'Indústrias',
      description: 'Sistemas de climatização para galpões e áreas de produção.',
    },
    {
      icon: Store,
      title: 'Comércios',
      description: 'Soluções para lojas, restaurantes e estabelecimentos comerciais.',
    },
    {
      icon: Building,
      title: 'Instituições',
      description: 'Projetos para hospitais, clínicas e instituições de ensino.',
    },
  ];

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-20 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-testid="portfolio-header">
          <span className="font-manrope text-sm font-bold tracking-[0.2em] uppercase text-sky-600">
            Áreas de Atuação
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 mt-4 mb-6">
            Projetos para diversos segmentos
          </h2>
          <div className="section-divider mx-auto mb-6"></div>
          <p className="font-manrope text-base sm:text-lg text-slate-600 leading-relaxed">
            Desenvolvemos projetos de climatização para diferentes tipos de clientes, 
            sempre com foco na eficiência e nas necessidades específicas de cada ambiente.
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-testid="portfolio-grid">
          {/* Large Image Card */}
          <div
            className="portfolio-card relative overflow-hidden rounded-2xl shadow-xl group"
            data-testid="portfolio-card-main"
          >
            <div className="overflow-hidden">
              <img
                src={PORTFOLIO_IMAGE}
                alt="Edifício comercial com sistema de climatização"
                className="portfolio-image w-full h-[400px] object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span className="inline-block bg-sky-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                Comercial
              </span>
              <h3 className="font-outfit text-2xl font-semibold text-white mb-2">
                Edifícios Corporativos
              </h3>
              <p className="font-manrope text-sm text-white/80">
                Soluções de climatização para ambientes de alto padrão
              </p>
            </div>
          </div>

          {/* Second Image Card */}
          <div
            className="portfolio-card relative overflow-hidden rounded-2xl shadow-xl group"
            data-testid="portfolio-card-secondary"
          >
            <div className="overflow-hidden">
              <img
                src={SERVICES_IMAGE}
                alt="Técnico realizando manutenção em sistema externo"
                className="portfolio-image w-full h-[400px] object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <span className="inline-block bg-sky-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                Industrial
              </span>
              <h3 className="font-outfit text-2xl font-semibold text-white mb-2">
                Manutenção Especializada
              </h3>
              <p className="font-manrope text-sm text-white/80">
                Serviços técnicos para sistemas de grande porte
              </p>
            </div>
          </div>
        </div>

        {/* Project Types */}
        <div
          className="grid grid-cols-2 lg:grid-cols-4 gap-4"
          data-testid="portfolio-types"
        >
          {projectTypes.map((type, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-2xl p-6 text-center hover:bg-sky-50 transition-colors duration-300"
              data-testid={`portfolio-type-${index}`}
            >
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mx-auto mb-4 shadow-sm">
                <type.icon className="w-6 h-6 text-sky-600" strokeWidth={1.5} />
              </div>
              <h3 className="font-outfit text-sm lg:text-base font-semibold text-slate-800 mb-1">
                {type.title}
              </h3>
              <p className="font-manrope text-xs text-slate-500 hidden lg:block">
                {type.description}
              </p>
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="text-center font-manrope text-sm text-slate-500 mt-8" data-testid="portfolio-note">
          Portfólio de projetos realizados disponível mediante solicitação.
        </p>
      </div>
    </section>
  );
};
